import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../../common/models/Visiable";
import { UpsellState } from "../models/UpsellsState";

const setMessageVisiable = (state: UpsellState, action: PayloadAction<Visiable>) => {
    state.messageVisiable = action.payload.visiable;
}

export default setMessageVisiable;